import { css } from "@emotion/react";
import { bpoints } from "../../../Utils";

export function headerCotCSS(colorBarWidth = 20, actualStep){
    return css`
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 1.5vw 4vw 1.5vw 4vw; // Top Right Bottom Left
        position: relative;

        @media (max-width: ${bpoints.mobile.w}px){
            padding: 3vh 6vw 0 6vw;
        }

        .Container{
            width: 100%;
            //display: grid;
            //grid-template-columns: 1fr 1fr 1fr;
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;

            @media (max-width: ${bpoints.mobile.w}px){
                gap: 1rem;
            }
            
            .GridItem{
                //background-color: aliceblue;
                display: flex;
                align-items: center;

                font-size: calc(0.6rem + 0.3vw);
            }

            .Pointer{
                cursor: pointer;
            }

            .Left{
                gap: 2rem;

                img{
                    width: calc(1.5rem + 9vw);

                    @media (max-width: ${bpoints.mobile.w}px){
                        width: calc(3rem + 25vw);
                    }
                }
            }

            .Center{
                width: 50%;
                height: 100%;
                position: absolute;
                top: 0;
                left: 50%;
                translate: -50% 0;

                @media (max-width: ${bpoints.mobile.w}px){
                    width: 100%;
                    position: relative;
                    translate: unset;
                    left: unset;
                    top: unset;
                    order: 3;
                    font-size: 1rem;
                }

                .ProgressIndicator{
                    position: relative;
                    width: 100%;
                    
                    display: flex;
                    justify-content: space-between;
                    
                    padding-top: 2.1%;
                    padding-bottom: 2.1%;
                    
                    border-top: solid 1px #34B9E0;
                    border-bottom: solid 1px #CECECE;
                    transition: width 200ms;

                    @media (max-width: ${bpoints.mobile.w}px){
                        padding-top: 4.1%;
                        padding-bottom: 4.1%;
                    }

                    .Step{
                        color: black;
                        font-style: normal;
                        font-weight: 400;
                        letter-spacing: 0.36px;

                        @media (max-width: ${bpoints.mobile.w}px){
                            [class^="ConditionallyHidden"] {
                                display: none;
                            }
    
                            .ConditionallyHidden${actualStep}{
                                display: inline;
                            }
    
                            .ConditionallyHidden${actualStep + 1}{
                                display: inline;
                            }

                        }

                    }

                    .Inactive{
                        color: #CECECE;
                    }

                    .ColorBar{
                        height: 4px;
                        width: ${colorBarWidth}%;
                        
                        position: absolute;
                        left: 0;
                        bottom: 0;

                        background: linear-gradient(90deg, #204B7B 0%, #32B8DF 51.56%, #24B56E 100%);

                    }
                }
            }

            .Right{
                .Nav{
                    display: flex;
                    flex-grow: 1;
                    //justify-content: space-evenly;
                    gap: 2rem;

                    @media (max-width: ${bpoints.mobile.w}px){
                        display: none;
                    }

                    span{
                        cursor: pointer;

                        a{
                            text-decoration: none;
                            color: inherit;
                        }
                    }
                }

                .SideMenuContainer{
                    display: none;

                    .Icon{
                        font-size: calc(1rem + 4vw);
                        color: #32B8DF;
                    }

                    @media (max-width: ${bpoints.mobile.w}px){
                        display: unset;
                    }

                    .MobileNav{
                        display: flex;
                        flex-direction: column;
                        gap: 2vh;
                        margin-top: 2vh;
                        font-weight: 500;
                        
                        font-size: calc(1rem + 3vw);

                        text-align: right;
                        color: #4a4a4a;
                    }
                }
            }
        }


    `;
}